import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { fetchKeywordTrend } from '../../../api/reportApi.js';
import type { KeywordTrendResponse, KeywordTrendWeeks } from '../../../types/report.js';

export const useKeywordTrend = (
  target:
    | {
        campaignName: string;
        campaignId: string | null;
        adGroupName: string | null;
        adGroupId: string | null;
        keywordName: string;
        keywordId: string | null;
        orgId: string | null;
      }
    | null,
  weeks: KeywordTrendWeeks = 12
) =>
  useQuery<KeywordTrendResponse, Error>({
    queryKey: [
      'keyword-trend',
      target?.campaignId,
      target?.adGroupId,
      target?.keywordId,
      target?.campaignName,
      target?.adGroupName,
      target?.keywordName,
      target?.orgId,
      weeks,
    ],
    queryFn: ({ signal }) => {
      if (!target) {
        throw new Error('Missing keyword target');
      }
      return fetchKeywordTrend(target, weeks, { signal });
    },
    enabled: Boolean(target),
    placeholderData: keepPreviousData,
  });
